<template>
  <router-link v-if="customer.term.red_flagged" :to="{name: 'customers.terms', params: {id: customer.uuid}}">
    <b-tooltip :target="`red-flag-${uuid}`">
      <template v-slot:default>
        <span class="red-flag-comment" v-html="customer.term.red_flag_comment"/>
      </template>
    </b-tooltip>
    <font-awesome-icon icon="flag" class="icon text-danger mr-3 red-flag-icon" :id="`red-flag-${uuid}`"/>
  </router-link>
</template>

<script>
  import {uuid} from 'vue-uuid';

  export default {
    data: () => {
      return {
        uuid: uuid.v4()
      }
    },
    name: "RedFlagDisplayer",
    props: ['customer'],
  }
</script>

<style lang="scss" scoped>
  .red-flag-icon {
    cursor: pointer;
    outline: none !important;
  }

  .red-flag-comment {
    /deep/ > p {
      margin: 0;
    }
  }
</style>

